import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_DATE_CALCULATION,
  OPERATOR_TYPES_4,
  OPERATOR_TYPES_6,
} from 'dashboard/constants/conditionOperators';

// Data da última mensagem enviada/recebida no motor de fluxos (#1768): os
// operadores que o ConditionsFilterService avalia, mais o inverso de "nos
// últimos" — "não nos últimos N", que casa também quem nunca teve mensagem
// daquele tipo. Ele é só dos fluxos: os filtros de conversa não o compilam.
export const FLOW_LAST_MESSAGE_OPERATORS = [
  OPERATOR_TYPES_DATE_CALCULATION[0],
  {
    value: 'not_in_last',
    label: 'Not in the last',
  },
  ...OPERATOR_TYPES_DATE_CALCULATION.slice(1),
];

// "Dias sem mensagem" (#1921): dias de calendário, no fuso da conta, desde a última mensagem que
// conta. Duas chaves em vez de um campo extra: o editor de condição não tem onde pendurar uma
// opção ao lado do valor, e cada chave diz sozinha o que conta. A de "cliente e equipe" ignora as
// mensagens automáticas (fluxo, campanha, bot). O valor é um inteiro; os operadores são só os
// três que o backend aceita (FilterService::DAYS_WITHOUT_MESSAGE_OPERATORS).
export const DAYS_WITHOUT_MESSAGE_OPERATORS = OPERATOR_TYPES_4.filter(
  operator =>
    ['equal_to', 'is_greater_than', 'is_less_than'].includes(operator.value)
);

export const DAYS_WITHOUT_MESSAGE_CONDITIONS = [
  {
    key: 'days_without_received_message',
    name: 'Dias sem mensagem do cliente',
    attributeI18nKey: 'DAYS_WITHOUT_RECEIVED_MESSAGE',
    inputType: 'plain_text',
    filterOperators: DAYS_WITHOUT_MESSAGE_OPERATORS,
  },
  {
    key: 'days_without_any_message',
    name: 'Dias sem mensagem (cliente e equipe)',
    attributeI18nKey: 'DAYS_WITHOUT_ANY_MESSAGE',
    inputType: 'plain_text',
    filterOperators: DAYS_WITHOUT_MESSAGE_OPERATORS,
  },
];

// Lista unificada de todas as ações disponíveis para todos os eventos
const ALL_AUTOMATION_ACTIONS = [
  {
    key: 'assign_task_to_conversation',
    name: 'Atribuir Tarefa a Conversa',
    attributeI18nKey: 'ASSIGN_TASK_TO_CONVERSATION',
  },
  {
    key: 'assign_task_to_contact',
    name: 'Atribuir Tarefa ao Contato',
    attributeI18nKey: 'ASSIGN_TASK_TO_CONTACT',
  },
  {
    key: 'assign_task_to_company',
    name: 'Atribuir Tarefa à Empresa',
    attributeI18nKey: 'ASSIGN_TASK_TO_COMPANY',
  },
  {
    key: 'complete_conversation_task',
    name: 'Concluir Tarefa de Conversa',
    attributeI18nKey: 'COMPLETE_CONVERSATION_TASK',
  },
  {
    key: 'complete_contact_task',
    name: 'Concluir Tarefa de Contato',
    attributeI18nKey: 'COMPLETE_CONTACT_TASK',
  },
  {
    key: 'complete_company_task',
    name: 'Concluir Tarefa de Empresa',
    attributeI18nKey: 'COMPLETE_COMPANY_TASK',
  },
  {
    key: 'create_calendar_event',
    name: 'Criar Evento na Agenda',
    attributeI18nKey: 'CREATE_CALENDAR_EVENT',
  },
  {
    key: 'schedule_meeting',
    name: 'Agendar Reunião',
    attributeI18nKey: 'SCHEDULE_MEETING',
  },
  {
    key: 'start_typebot',
    name: 'Iniciar Bot',
    attributeI18nKey: 'START_TYPEBOT',
  },
  {
    key: 'stop_typebot',
    name: 'Parar Bot',
    attributeI18nKey: 'STOP_TYPEBOT',
  },
  {
    key: 'reset_typebot',
    name: 'Reiniciar Bot',
    attributeI18nKey: 'RESET_TYPEBOT',
  },
  {
    key: 'start_ai_agent',
    name: 'Ligar Agente de IA',
    attributeI18nKey: 'START_AI_AGENT',
  },
  {
    key: 'stop_ai_agent',
    name: 'Parar Agente de IA',
    attributeI18nKey: 'STOP_AI_AGENT',
  },
  {
    key: 'reset_ai_agent',
    name: 'Reiniciar Agente de IA',
    attributeI18nKey: 'RESET_AI_AGENT',
  },
  {
    key: 'execute_flow',
    name: 'Executar Fluxo',
    attributeI18nKey: 'EXECUTE_FLOW',
  },
  {
    key: 'assign_agent',
    name: 'Atribuir um Atendente a Conversa',
    attributeI18nKey: 'ASSIGN_AGENT',
  },
  {
    key: 'assign_team',
    name: 'Atribuir um Setor a Conversa',
    attributeI18nKey: 'ASSIGN_TEAM',
  },
  {
    key: 'assign_agent_to_contact',
    name: 'Atribuir um Atendente ao Contato',
    attributeI18nKey: 'ASSIGN_AGENT_TO_CONTACT',
  },
  {
    key: 'assign_team_to_contact',
    name: 'Atribuir um Setor ao Contato',
    attributeI18nKey: 'ASSIGN_TEAM_TO_CONTACT',
  },
  {
    key: 'remove_assigned_agent',
    name: 'Remover Atendente da Conversa',
    attributeI18nKey: 'REMOVE_ASSIGNED_AGENT',
  },
  {
    key: 'remove_assigned_team',
    name: 'Remover Setor da Conversa',
    attributeI18nKey: 'REMOVE_ASSIGNED_TEAM',
  },
  {
    key: 'assign_franchise_unit',
    name: 'Associar Unidade do Franqueado à Conversa',
    attributeI18nKey: 'ASSIGN_FRANCHISE_UNIT',
  },
  {
    key: 'remove_franchise_unit',
    name: 'Desassociar Unidade do Franqueado da Conversa',
    attributeI18nKey: 'REMOVE_FRANCHISE_UNIT',
  },
  {
    key: 'remove_contact_assigned_agent',
    name: 'Remover Atendente do Contato',
    attributeI18nKey: 'REMOVE_CONTACT_ASSIGNED_AGENT',
  },
  {
    key: 'remove_contact_assigned_team',
    name: 'Remover Setor do Contato',
    attributeI18nKey: 'REMOVE_CONTACT_ASSIGNED_TEAM',
  },
  {
    key: 'add_conversation_label',
    name: 'Adicionar etiqueta na conversa',
    attributeI18nKey: 'ADD_CONVERSATION_LABEL',
  },
  {
    key: 'remove_conversation_label',
    name: 'Remover etiqueta da conversa',
    attributeI18nKey: 'REMOVE_CONVERSATION_LABEL',
  },
  {
    key: 'add_contact_label',
    name: 'Adicionar etiqueta no contato',
    attributeI18nKey: 'ADD_CONTACT_LABEL',
  },
  {
    key: 'remove_contact_label',
    name: 'Remover etiqueta do contato',
    attributeI18nKey: 'REMOVE_CONTACT_LABEL',
  },
  {
    key: 'create_company',
    name: 'Criar empresa',
    attributeI18nKey: 'CREATE_COMPANY',
  },
  {
    key: 'update_company',
    name: 'Atualizar empresa',
    attributeI18nKey: 'UPDATE_COMPANY',
  },
  {
    key: 'assign_company_agent',
    name: 'Atribuir Atendente à Empresa',
    attributeI18nKey: 'ASSIGN_COMPANY_AGENT',
  },
  {
    key: 'assign_company_team',
    name: 'Atribuir Setor à Empresa',
    attributeI18nKey: 'ASSIGN_COMPANY_TEAM',
  },
  {
    key: 'add_company_label',
    name: 'Adicionar etiqueta na empresa',
    attributeI18nKey: 'ADD_COMPANY_LABEL',
  },
  {
    key: 'remove_company_label',
    name: 'Remover etiqueta da empresa',
    attributeI18nKey: 'REMOVE_COMPANY_LABEL',
  },
  {
    key: 'set_company_custom_attributes',
    name: 'Inserir Campo Personalizado na Empresa',
    attributeI18nKey: 'SET_COMPANY_CUSTOM_ATTRIBUTES',
  },
  {
    key: 'remove_company_custom_attributes',
    name: 'Remover Campo Personalizado da Empresa',
    attributeI18nKey: 'REMOVE_COMPANY_CUSTOM_ATTRIBUTES',
  },
  {
    key: 'associate_company_to_conversation',
    name: 'Associar empresa à conversa',
    attributeI18nKey: 'ASSOCIATE_COMPANY_TO_CONVERSATION',
  },
  {
    key: 'associate_company_to_contact',
    name: 'Associar empresa ao contato',
    attributeI18nKey: 'ASSOCIATE_COMPANY_TO_CONTACT',
  },
  {
    key: 'associate_company_to_company',
    name: 'Associar empresa à empresa',
    attributeI18nKey: 'ASSOCIATE_COMPANY_TO_COMPANY',
  },
  {
    key: 'send_email_to_team',
    name: 'Enviar um email para o setor',
    attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
  },
  {
    key: 'send_message',
    name: 'Enviar uma mensagem',
    attributeI18nKey: 'SEND_MESSAGE',
  },
  {
    key: 'send_template',
    name: 'Enviar template do WhatsApp Oficial',
    attributeI18nKey: 'SEND_TEMPLATE',
  },
  {
    key: 'send_button',
    name: 'Enviar botão',
    attributeI18nKey: 'SEND_BUTTON',
  },
  {
    key: 'send_list',
    name: 'Enviar lista',
    attributeI18nKey: 'SEND_LIST',
  },
  {
    key: 'send_carousel',
    name: 'Enviar carrossel',
    attributeI18nKey: 'SEND_CAROUSEL',
  },
  {
    key: 'send_poll',
    name: 'Enviar enquete',
    attributeI18nKey: 'SEND_POLL',
  },
  {
    key: 'send_private_note',
    name: 'Enviar uma nota privada',
    attributeI18nKey: 'SEND_PRIVATE_NOTE',
  },
  {
    key: 'send_email_transcript',
    name: 'Enviar uma transcrição por email',
    attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
  },
  {
    key: 'mute_conversation',
    name: 'Bloquear contato',
    attributeI18nKey: 'MUTE_CONVERSATION',
  },
  {
    key: 'snooze_conversation',
    name: 'Adiar conversa',
    attributeI18nKey: 'SNOOZE_CONVERSATION',
  },
  {
    key: 'resolve_conversation',
    name: 'Resolver conversa',
    attributeI18nKey: 'RESOLVE_CONVERSATION',
  },
  {
    key: 'open_conversation',
    name: 'Abrir conversa',
    attributeI18nKey: 'OPEN_CONVERSATION',
  },
  {
    key: 'send_webhook_event',
    name: 'Enviar Evento Webhook',
    attributeI18nKey: 'SEND_WEBHOOK_EVENT',
  },
  {
    key: 'send_attachment',
    name: 'Enviar Anexo',
    attributeI18nKey: 'SEND_ATTACHMENT',
  },
  {
    key: 'set_conversation_custom_attributes',
    name: 'Inserir Campo Personalizado na Conversa',
    attributeI18nKey: 'SET_CONVERSATION_CUSTOM_ATTRIBUTES',
  },
  {
    key: 'set_contact_custom_attributes',
    name: 'Inserir Campo Personalizado no Contato',
    attributeI18nKey: 'SET_CONTACT_CUSTOM_ATTRIBUTES',
  },
  {
    key: 'schedule_message',
    name: 'Agendar Mensagem',
    attributeI18nKey: 'SCHEDULE_MESSAGE',
  },
  {
    key: 'execute_macro',
    name: 'Executar Macro',
    attributeI18nKey: 'EXECUTE_MACRO',
  },
  {
    key: 'cancel_scheduled_messages',
    name: 'Cancelar Todos os Agendamentos',
    attributeI18nKey: 'CANCEL_SCHEDULED_MESSAGES',
  },
  {
    key: 'delete_scheduled_messages',
    name: 'Excluir Todos os Agendamentos',
    attributeI18nKey: 'DELETE_SCHEDULED_MESSAGES',
  },
  {
    key: 'create_conversation',
    name: 'Criar Conversa',
    attributeI18nKey: 'CREATE_CONVERSATION',
  },
];

// Lista de ações específicas para eventos de contato (sem etiquetas de conversa)
const CONTACT_AUTOMATION_ACTIONS = ALL_AUTOMATION_ACTIONS.filter(
  action =>
    !['add_conversation_label', 'remove_conversation_label'].includes(
      action.key
    )
);

const COMMON_CONDITIONS = [
  {
    key: 'task_due_date',
    name: 'Vencimento da Tarefa',
    attributeI18nKey: 'TASK_DUE_DATE',
    inputType: 'date',
    filterOperators: OPERATOR_TYPES_1,
    specialType: 'task_template_id',
  },
  {
    key: 'current_date',
    name: 'Data Atual do Sistema',
    attributeI18nKey: 'CURRENT_DATE',
    inputType: 'date',
    filterOperators: OPERATOR_TYPES_1,
  },
];

const COMPANY_RELATED_CONDITIONS = [
  {
    key: 'related_company_filter',
    name: 'Filtro de empresa relacionada',
    attributeI18nKey: 'RELATED_COMPANY_FILTER',
    inputType: 'company_relation_filter',
    filterOperators: [{ value: 'equal_to', label: 'igual a' }],
  },
  {
    key: 'company_id',
    name: 'Empresa relacionada',
    attributeI18nKey: 'RELATED_COMPANY',
    inputType: 'search_select',
    filterOperators: OPERATOR_TYPES_3,
  },
  {
    key: 'company_name',
    name: 'Nome da empresa relacionada',
    attributeI18nKey: 'RELATED_COMPANY_NAME',
    inputType: 'plain_text',
    filterOperators: OPERATOR_TYPES_2,
  },
  {
    key: 'company_labels',
    name: 'Etiquetas da empresa relacionada',
    attributeI18nKey: 'RELATED_COMPANY_LABELS',
    inputType: 'multi_select',
    filterOperators: OPERATOR_TYPES_2,
  },
  {
    key: 'company_assignee_id',
    name: 'Responsável da empresa relacionada',
    attributeI18nKey: 'RELATED_COMPANY_ASSIGNEE',
    inputType: 'search_select',
    filterOperators: OPERATOR_TYPES_3,
  },
  {
    key: 'company_team_id',
    name: 'Setor da empresa relacionada',
    attributeI18nKey: 'RELATED_COMPANY_TEAM',
    inputType: 'search_select',
    filterOperators: OPERATOR_TYPES_3,
  },
];

// Responsável/Setor do CONTATO da conversa (#1540). Em evento de conversa e de
// mensagem, `assignee_id`/`team_id` são os da CONVERSA; estas chaves cruzadas
// são avaliadas sobre o contato da conversa (Automations::Flows::
// ConditionsFilterService::CONTACT_CROSS_FILTERS). Em evento de contato o
// responsável do contato é o próprio `assignee_id`.
const CONTACT_OWNER_CONDITIONS = [
  {
    key: 'contact_assignee_id',
    name: 'Responsável do contato',
    attributeI18nKey: 'CONTACT_ASSIGNEE',
    inputType: 'search_select',
    filterOperators: OPERATOR_TYPES_3,
  },
  {
    key: 'contact_team_id',
    name: 'Setor do contato',
    attributeI18nKey: 'CONTACT_TEAM',
    inputType: 'search_select',
    filterOperators: OPERATOR_TYPES_3,
  },
];

const LEAD_SOURCE_CONDITION = {
  key: 'lead_source',
  name: 'Origem do lead',
  attributeI18nKey: 'LEAD_SOURCE',
  inputType: 'search_select',
  filterOperators: OPERATOR_TYPES_1,
};

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      {
        key: 'status',
        name: 'Status da Conversa',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'message_type',
        name: 'Tipo de Mensagem',
        attributeI18nKey: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'Conteúdo da Mensagem',
        attributeI18nKey: 'MESSAGE_CONTAINS',
        inputType: 'plain_text_area',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Canal',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Idioma da Conversa',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'conversation_labels',
        name: 'Etiquetas da conversa',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      ...CONTACT_OWNER_CONDITIONS,
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Idioma do Navegador',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Assunto do Email',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'País',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'Link de Referência',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Canal',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Idioma da Conversa',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Prioridade',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_labels',
        name: 'Etiquetas da conversa',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      ...CONTACT_OWNER_CONDITIONS,
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Idioma do Navegador',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Assunto do Email',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'País',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Link de Referência',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'Responsável da conversa',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Setor da conversa',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Canal',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Idioma da Conversa',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Prioridade',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_labels',
        name: 'Etiquetas da conversa',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'last_sent_messaged_at',
        name: 'Data da última mensagem enviada',
        attributeI18nKey: 'LAST_SENT_MESSAGED_AT',
        inputType: 'date_calculation',
        filterOperators: FLOW_LAST_MESSAGE_OPERATORS,
      },
      {
        key: 'last_received_messaged_at',
        name: 'Data da última mensagem recebida',
        attributeI18nKey: 'LAST_RECEIVED_MESSAGED_AT',
        inputType: 'date_calculation',
        filterOperators: FLOW_LAST_MESSAGE_OPERATORS,
      },
      ...DAYS_WITHOUT_MESSAGE_CONDITIONS,
      ...CONTACT_OWNER_CONDITIONS,
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  conversation_resolved: {
    conditions: [
      {
        key: 'status',
        name: 'Status',
        attributeI18nKey: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'Idioma do Navegador',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'Assunto do Email',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'País',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Link de Referência',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'Responsável da conversa',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Setor da conversa',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'Canal',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Idioma da Conversa',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Prioridade',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_labels',
        name: 'Etiquetas da conversa',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'last_sent_messaged_at',
        name: 'Data da última mensagem enviada',
        attributeI18nKey: 'LAST_SENT_MESSAGED_AT',
        inputType: 'date_calculation',
        filterOperators: FLOW_LAST_MESSAGE_OPERATORS,
      },
      {
        key: 'last_received_messaged_at',
        name: 'Data da última mensagem recebida',
        attributeI18nKey: 'LAST_RECEIVED_MESSAGED_AT',
        inputType: 'date_calculation',
        filterOperators: FLOW_LAST_MESSAGE_OPERATORS,
      },
      ...DAYS_WITHOUT_MESSAGE_CONDITIONS,
      ...CONTACT_OWNER_CONDITIONS,
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'Idioma do Navegador',
        attributeI18nKey: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'Assunto do Email',
        attributeI18nKey: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'País',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'Link de Referência',
        attributeI18nKey: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Responsável da conversa',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'Setor da conversa',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'Canal',
        attributeI18nKey: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'Idioma da Conversa',
        attributeI18nKey: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'Prioridade',
        attributeI18nKey: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_labels',
        name: 'Etiquetas da conversa',
        attributeI18nKey: 'CONVERSATION_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'last_sent_messaged_at',
        name: 'Data da última mensagem enviada',
        attributeI18nKey: 'LAST_SENT_MESSAGED_AT',
        inputType: 'date_calculation',
        filterOperators: FLOW_LAST_MESSAGE_OPERATORS,
      },
      {
        key: 'last_received_messaged_at',
        name: 'Data da última mensagem recebida',
        attributeI18nKey: 'LAST_RECEIVED_MESSAGED_AT',
        inputType: 'date_calculation',
        filterOperators: FLOW_LAST_MESSAGE_OPERATORS,
      },
      ...DAYS_WITHOUT_MESSAGE_CONDITIONS,
      ...CONTACT_OWNER_CONDITIONS,
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  contact_created: {
    conditions: [
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'name',
        name: 'Nome',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'country_code',
        name: 'País',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Responsável do contato',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Setor do contato',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: CONTACT_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  contact_updated: {
    conditions: [
      {
        key: 'email',
        name: 'Email',
        attributeI18nKey: 'EMAIL',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'name',
        name: 'Nome',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'Número de Telefone',
        attributeI18nKey: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'country_code',
        name: 'País',
        attributeI18nKey: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'contact_labels',
        name: 'Etiquetas do contato',
        attributeI18nKey: 'CONTACT_LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Responsável do contato',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Setor do contato',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      LEAD_SOURCE_CONDITION,
      ...COMMON_CONDITIONS,
    ],
    actions: CONTACT_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  company_created: {
    conditions: [
      {
        key: 'name',
        name: 'Nome',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'website_url',
        name: 'Website',
        attributeI18nKey: 'WEBSITE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'labels',
        name: 'Etiquetas',
        attributeI18nKey: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Responsável da empresa',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Setor da empresa',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
  company_updated: {
    conditions: [
      {
        key: 'name',
        name: 'Nome',
        attributeI18nKey: 'NAME',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'website_url',
        name: 'Website',
        attributeI18nKey: 'WEBSITE',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'labels',
        name: 'Etiquetas',
        attributeI18nKey: 'LABELS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'Responsável da empresa',
        attributeI18nKey: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'Setor da empresa',
        attributeI18nKey: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'contact_id',
        name: 'Contato relacionado',
        attributeI18nKey: 'RELATED_CONTACT',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'related_company_filter',
        name: 'Filtro de empresa relacionada',
        attributeI18nKey: 'RELATED_COMPANY_FILTER',
        inputType: 'company_relation_filter',
        filterOperators: [{ value: 'equal_to', label: 'igual a' }],
      },
      {
        key: 'related_company_id',
        name: 'Empresa relacionada',
        attributeI18nKey: 'RELATED_COMPANY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      ...COMMON_CONDITIONS,
    ],
    actions: ALL_AUTOMATION_ACTIONS,
    custom_attribute_support: true,
  },
};

Object.keys(AUTOMATIONS).forEach(eventName => {
  if (!eventName.startsWith('company_')) {
    AUTOMATIONS[eventName].conditions.push(...COMPANY_RELATED_CONDITIONS);
  }
});

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'Conversa Criada',
  },
  {
    key: 'conversation_updated',
    value: 'Conversa Atualizada',
  },
  {
    key: 'conversation_resolved',
    value: 'Conversa Resolvida',
  },
  {
    key: 'message_created',
    value: 'Mensagem Criada',
  },
  {
    key: 'conversation_opened',
    value: 'Conversa Aberta',
  },
  {
    key: 'contact_created',
    value: 'Contato Criado',
  },
  {
    key: 'contact_updated',
    value: 'Contato Atualizado',
  },
  {
    key: 'company_created',
    value: 'Empresa Criada',
  },
  {
    key: 'company_updated',
    value: 'Empresa Atualizada',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'create_calendar_event',
    label: 'Criar Evento na Agenda',
    inputType: 'calendar_event',
  },
  {
    key: 'schedule_meeting',
    label: 'Agendar Reunião',
    inputType: 'calendar_event',
  },
  {
    key: 'assign_task_to_conversation',
    label: 'Atribuir Tarefa a Conversa',
    inputType: 'search_select',
  },
  {
    key: 'assign_task_to_contact',
    label: 'Atribuir Tarefa ao Contato',
    inputType: 'search_select',
  },
  {
    key: 'assign_task_to_company',
    label: 'Atribuir Tarefa à Empresa',
    inputType: 'search_select',
  },
  {
    key: 'complete_conversation_task',
    label: 'Concluir Tarefa de Conversa',
    inputType: 'search_select',
  },
  {
    key: 'complete_contact_task',
    label: 'Concluir Tarefa de Contato',
    inputType: 'search_select',
  },
  {
    key: 'complete_company_task',
    label: 'Concluir Tarefa de Empresa',
    inputType: 'search_select',
  },
  {
    key: 'start_typebot',
    label: 'Iniciar Bot',
    inputType: 'start_typebot_command',
  },
  {
    key: 'stop_typebot',
    label: 'Parar Bot',
    inputType: null,
  },
  {
    key: 'reset_typebot',
    label: 'Reiniciar Bot',
    inputType: null,
  },
  {
    key: 'start_ai_agent',
    label: 'Ligar Agente de IA',
    inputType: 'start_ai_agent',
  },
  {
    key: 'stop_ai_agent',
    label: 'Parar bot e IA',
    inputType: null,
  },
  {
    key: 'reset_ai_agent',
    label: 'Reiniciar bot e IA',
    inputType: null,
  },
  {
    key: 'execute_flow',
    label: 'Disparar fluxo manual',
    inputType: 'search_select',
  },
  {
    key: 'assign_agent',
    label: 'Atribuir um Atendente a Conversa',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'Atribuir um Setor a Conversa',
    inputType: 'search_select',
  },
  {
    key: 'assign_agent_to_contact',
    label: 'Atribuir um Atendente ao Contato',
    inputType: 'search_select',
  },
  {
    key: 'assign_team_to_contact',
    label: 'Atribuir um Setor ao Contato',
    inputType: 'search_select',
  },
  {
    key: 'add_conversation_label',
    label: 'Adicionar etiqueta na conversa',
    inputType: 'multi_select',
  },
  {
    key: 'remove_conversation_label',
    label: 'Remover etiqueta da conversa',
    inputType: 'multi_select',
  },
  {
    key: 'add_contact_label',
    label: 'Adicionar etiqueta no contato',
    inputType: 'multi_select',
  },
  {
    key: 'remove_contact_label',
    label: 'Remover etiqueta do contato',
    inputType: 'multi_select',
  },
  {
    key: 'create_company',
    label: 'Criar empresa',
    inputType: 'company',
  },
  {
    key: 'update_company',
    label: 'Atualizar empresa',
    inputType: 'company',
  },
  {
    key: 'assign_company_agent',
    label: 'Atribuir Atendente à Empresa',
    inputType: 'company_assignment',
  },
  {
    key: 'assign_company_team',
    label: 'Atribuir Setor à Empresa',
    inputType: 'company_assignment',
  },
  {
    key: 'add_company_label',
    label: 'Adicionar etiqueta na empresa',
    inputType: 'multi_select',
  },
  {
    key: 'remove_company_label',
    label: 'Remover etiqueta da empresa',
    inputType: 'multi_select',
  },
  {
    key: 'set_company_custom_attributes',
    label: 'Inserir Campo Personalizado na Empresa',
    inputType: 'custom_attribute',
  },
  {
    key: 'remove_company_custom_attributes',
    label: 'Remover Campo Personalizado da Empresa',
    inputType: 'custom_attribute',
  },
  {
    key: 'associate_company_to_conversation',
    label: 'Associar empresa à conversa',
    inputType: 'company',
  },
  {
    key: 'associate_company_to_contact',
    label: 'Associar empresa ao contato',
    inputType: 'company',
  },
  {
    key: 'associate_company_to_company',
    label: 'Associar empresa à empresa',
    inputType: 'company',
  },
  {
    key: 'send_email_to_team',
    label: 'Enviar um email para o setor',
    inputType: 'team_message',
  },
  {
    key: 'remove_assigned_agent',
    label: 'Remover Atendente da Conversa',
    inputType: null,
  },
  {
    key: 'remove_assigned_team',
    label: 'Remover Setor da Conversa',
    inputType: null,
  },
  {
    key: 'assign_franchise_unit',
    label: 'Associar Unidade do Franqueado à Conversa',
    inputType: 'franchise_unit',
  },
  {
    key: 'remove_franchise_unit',
    label: 'Desassociar Unidade do Franqueado da Conversa',
    inputType: null,
  },
  {
    key: 'remove_contact_assigned_agent',
    label: 'Remover Atendente do Contato',
    inputType: null,
  },
  {
    key: 'remove_contact_assigned_team',
    label: 'Remover Setor do Contato',
    inputType: null,
  },
  {
    key: 'send_email_transcript',
    label: 'Enviar uma transcrição por email',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'Bloquear contato',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'Adiar conversa',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'Resolver conversa',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'Abrir conversa',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'Enviar Evento Webhook',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'Enviar Anexo',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'Enviar uma mensagem',
    inputType: 'message_with_inbox',
  },
  {
    key: 'send_template',
    label: 'Enviar template do WhatsApp Oficial',
    inputType: 'whatsapp_template',
  },
  {
    key: 'send_button',
    label: 'Enviar botão',
    inputType: 'interactive_button',
  },
  {
    key: 'send_list',
    label: 'Enviar lista',
    inputType: 'interactive_list',
  },
  {
    key: 'send_carousel',
    label: 'Enviar carrossel',
    inputType: 'interactive_carousel',
  },
  {
    key: 'send_poll',
    label: 'Enviar enquete',
    inputType: 'interactive_poll',
  },
  {
    key: 'send_private_note',
    label: 'Enviar uma nota privada',
    inputType: 'message_with_inbox',
    attributeI18nKey: 'SEND_PRIVATE_NOTE',
  },
  {
    key: 'change_priority',
    label: 'Alterar Prioridade',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'Adicionar SLA',
    inputType: 'search_select',
  },
  {
    key: 'create_conversation',
    label: 'Criar Conversa',
    inputType: 'create_conversation',
  },
  {
    key: 'set_conversation_custom_attributes',
    label: 'Inserir Campo Personalizado na Conversa',
    inputType: 'custom_attribute',
  },
  {
    key: 'set_contact_custom_attributes',
    label: 'Inserir Campo Personalizado no Contato',
    inputType: 'custom_attribute',
  },
  {
    key: 'schedule_message',
    label: 'Agendar Mensagem',
    inputType: 'schedule_message',
  },
  {
    key: 'execute_macro',
    label: 'Executar Macro',
    attributeI18nKey: 'EXECUTE_MACRO',
    inputType: 'execute_macro',
  },
  {
    key: 'cancel_scheduled_messages',
    label: 'Cancelar Todos os Agendamentos',
    attributeI18nKey: 'CANCEL_SCHEDULED_MESSAGES',
    inputType: null,
  },
  {
    key: 'delete_scheduled_messages',
    label: 'Excluir Todos os Agendamentos',
    attributeI18nKey: 'DELETE_SCHEDULED_MESSAGES',
    inputType: null,
  },
];
